export default __webpack_public_path__ + "static/smbBanner2mob-e70f9df57956347afc376a94389effeb.png";